import React, { useState, useEffect } from 'react';

import './styles.css';

import documentsServices from '../../../services/academy/documentsServices';

import ActivityIndicator from '../../../components/ActivityIndicator';
import MainView from '../../../components/MainView';
import NavHistory from '../../../components/NavHistory';
import PopupNewDocument from './PopupNewDocument';
import DocumentsListItem from './DocumentsListItem';
import { FaRegFileAlt } from 'react-icons/fa';

function Documents() {
    const [popupNewDocumentVisible, setPopupNewDocumentVisible] = useState(false);
    const [documents, setDocuments] = useState([]);
    const [fetching, setFetching] = useState(true);

    useEffect(() => {
        readDocuments();
    }, []);

    async function readDocuments() {
        const response = await documentsServices.getAcademyDocument();
        setFetching(false);
        if (response.status === 200) {
            setDocuments(response.data.reverse());
        } else
            alert("Erro ao listar documentos, tente novamente!");
    };

    function onDelete(index, array = documents, setArray = setDocuments) {
        setArray([...array.slice(0, index), ...array.slice(index + 1, array.length)]);
    }

    return (
        <MainView currentPage='home'>
            <NavHistory navPages={['Documentos administrativos']} />

            <div className='documents-page-list'>
                <div className='documents-page-list-header'>
                    <h4><b><FaRegFileAlt />Documentos</b></h4>
                    <span>{documents.length} documentos</span>
                </div>

                <button onClick={() => setPopupNewDocumentVisible(true)}>Adicionar documento</button>
                <PopupNewDocument
                    visibility={popupNewDocumentVisible}
                    setVisibility={setPopupNewDocumentVisible}
                    onCreate={readDocuments}
                />

                {
                    !fetching ?
                        documents.length ?
                            <ul className='documents-page-list-items'>
                                {
                                    documents.map((item, index) =>
                                        <DocumentsListItem
                                            key={item.id}
                                            index={index}
                                            id={item.id}
                                            type='pdf'
                                            tittle={item.nome}
                                            date={item.data}
                                            href={item.documento}
                                            onDelete={onDelete}
                                        />
                                    )
                                }
                            </ul>
                            : []
                        : <ActivityIndicator />
                }
            </div>
        </MainView>
    )
}

export default Documents;